'use strict';
var getScript = require("./util/getScript");
var Message = require('@tencent/message');
var ua = require('@tencent/txv.ua')();
// var report = require("./monitor/report");
/**
 * 手Q 微信 腾讯视频app各种bridge的facade
 */
var _callbacks = [];
var _ready = false;
var _bridge = null;
var _status = Object.create({}, {
	ready: {
		set: function (v) {
			if (_ready == v) {
				return;
			}
			_ready = v;
			// report("//btrace.qq.com/kvcollect?BossId=3882&Pwd=784260133" +
			// 	"&event=" + (ua.browser.name + (_bridge ? 'suc': 'fail')) +
			// 	"&ua=" + navigator.userAgent +
			// 	"&qq=0&vuserid=0&main_login=0&" +
			// 	"refer=" + document.referrer +
			// 	"&url=" + location.href +
			// 	"&_dc=" + Math.random());
			var cb;
			while (cb = _callbacks.shift()) {
				setTimeout((function (cb) {
					return function () {
						cb(_bridge);
					}
				})(cb), 0);
			}
		},
		get: function () {
			return _ready;
		}
	}
});

var win = window == top ? window : top;

var exportee = function (cb) {
	if (_status.ready) {
		cb(_bridge);
	} else {
		_callbacks.push(cb);
	}
};
exportee.QQvideoBridgeCallback = function commonBridgeCallback(cb) {
	return function (json) {
		var obj;
		try {
			if (typeof json == 'string') {
				obj = JSON.parse(json);

			} else {
				obj = json;
			}

		} catch (e) {
			try {
				obj = JSON.parse(decodeURIComponent(json));

			} catch (e) {
				return cb(e.message, null, json);
			}
		}

		if (obj.errCode == 0) {
			cb(null, obj, json);

		} else {
			cb(obj.errCode + ':' + obj.errMsg, obj, json);
		}
	}
};
module.exports = exportee;

/**
 * 在跨域的iframe中，直接获取tenvideojsbridge会报错
 * @param {*} scope 
 */
function _tryToGetTenvideoJsBridge(scope) {
	var bridge = null;
	if (!scope) return null;
	try {
		bridge = scope.TenvideoJSBridge || scope.WebViewJavascriptBridge
	} catch(e) {}
	return bridge;
}

if (ua.browser.WeChat) {
	var jsready = false;
	var bridgeready = false;

	var ready = function (name) {
		if (name == 'bridge') bridgeready = true;
		if (name == 'js') jsready = true;

		if (jsready && bridgeready) {
			_bridge = win.WeixinJSBridge;
			_status.ready = true;
		}
	};

	if (!top.WeixinJSBridge) {
		try {
			win.document.addEventListener("WeixinJSBridgeReady", function () {
				ready('bridge');
			});

		} catch (e) {
			_bridge = null;
			_status.ready = true;
		}

	} else {
		ready('bridge')
	}

	if (!win.wx) {
		getScript('//res.wx.qq.com/open/js/jweixin-1.2.0.js', function () {
			ready('js');
		})
	} else {
		ready('js')
	}

	setTimeout(function () {
		if (!_status.ready) {
			_bridge = null;
			_status.ready = true;
		}
	}, 10000);

} else if (ua.browser.MQQClient) {

	if (window.mqq || window.QQApi) {
		_bridge = window.mqq || window.QQApi;
		_status.ready = true;

	} else {
		var apiurl = '//s.url.cn/qqmobile/qqapi.js?_bid=152';
		getScript(apiurl, function () {
			_bridge = window.mqq || window.QQApi;
			_status.ready = true;
		});
	}
	setTimeout(function () {
		if (!_status.ready) {
			_bridge = null;
			_status.ready = true;
		}
	}, 6000);

} else if (ua.browser.QQvideo) {
	if (_tryToGetTenvideoJsBridge(win)) {
		QQLiveReady()

	} else {
		document.addEventListener('onTenvideoJSBridgeReady', QQLiveReady);
		document.addEventListener('WebViewJavascriptBridgeReady', QQLiveReady);
		var timer = setInterval(function () {
			if (_tryToGetTenvideoJsBridge(win)) {
				clearInterval(timer);
				QQLiveReady();
			} else if (_status.ready) {
				clearInterval(timer);
			}

		}, 200);
		setTimeout(function () {
			if (!_status.ready) {
				_bridge = null;
				_status.ready = true;
			}
		}, 6000);
	}

} else if (ua.browser.Submarine) {
	// 片多多jsb技术文档，http://test-submarine.sparta.html5.qq.com/_debug-jsapi.html
	if (top.SubmarineJSBridge) {
		_bridge = top.SubmarineJSBridge
	} else {
		document.addEventListener('onSubmarineJSBridgeReady', function() {
			_bridge = top.SubmarineJSBridge
		}, false);
	}
} else if (ua.browser.qqnews) {

	if (window.TencentNews) {
		_bridge = window.TencentNews;
		_status.ready = true;

	} else {
		getScript('http://mat1.gtimg.com/www/js/newsapp/jsapi/news.js?_tsid=1', function () {
			if (window.TencentNews) {
				_bridge = window.TencentNews;
				_status.ready = true;

			} else {
				// ios下偶现拉完js依然没对象。
				var timer = setInterval(function () {
					if (window.TencentNews || _status.ready) {
						clearInterval(timer);
						_bridge = window.TencentNews;
						_status.ready = true;
					}
				}, 500)
			}
		});
	}
	setTimeout(function () {
		if (!_status.ready) {
			_bridge = null;
			_status.ready = true;
		}
	}, 6000);
} else if (ua.browser.sukan) {
	
	if (window.WebViewJavascriptBridge) {
		_bridge = window.WebViewJavascriptBridge;
		_status.ready = true;
	} else {
		if(window.WVJBCallbacks) {
			window.WVJBCallbacks.push(function () {
				_bridge = window.WebViewJavascriptBridge;
				_status.ready = true;
			})
		} else {
			// 当bridge ready时，APP会主动调用该callbacks数组
			window.WVJBCallbacks = [function () {
				_bridge = window.WebViewJavascriptBridge;
				_status.ready = true;
			}]
			var WVJBIframe = document.createElement('iframe');
			WVJBIframe.style.display = 'none';
			WVJBIframe.src = 'https://__bridge_loaded__';
			document.documentElement.appendChild(WVJBIframe);
			setTimeout(function () { 
				document.documentElement.removeChild(WVJBIframe) 
			}, 0);
		}
	}
	setTimeout(function () {
		if (!_status.ready) {
			_bridge = null;
			_status.ready = true;
		}
	}, 6000);
} else {
	_bridge = null;
	_status.ready = false;
}

function QQLiveReady() {
	if (top.WebViewJavascriptBridge) {
		top.TenvideoJSBridge = top.WebViewJavascriptBridge;
		top.TenvideoJSBridge.invoke = top.WebViewJavascriptBridge.callHandler;
		top.TenvideoJSBridge.on = top.WebViewJavascriptBridge.registerHandler;
	}
	var message = new Message;

	_bridge = top.TenvideoJSBridge;
	var on = _bridge.on;

	
	_bridge.on = function (evt, callback) {
		if (!message._evtObjs[evt] || !message._evtObjs[evt].length) {
			on.call(_bridge, evt, function (json) {
				message.emit(evt, json);
			});
		}
		message.on(evt, callback);
	}
	_status.ready = true;

	try {
		// 原生jsbridge的on方法被修改时，加一个标记位，同时抛出一个相关事件，以便外部使用方可以兼容
		_bridge.isOnMethodOverride = true;
		var onMethodOverrideEventExt = top.document.createEvent('Events');
		onMethodOverrideEventExt.initEvent('onTenvideoJSBridgeOnMethodOverride');
		top.document.dispatchEvent(onMethodOverrideEventExt);
	} catch(e) {
		
	}
}